import React from 'react'
// libs
import { Field } from 'redux-form'
// components
import Switch, { SwitchProps } from '@mui/material/Switch'
import InputLabel from 'components/FormElements/components/InputLabel'
import ErrorMessage from 'components/UI/ErrorMessage'
// icons
import LockIconOrigin from '@mui/icons-material/LockOutlined'
// views
import { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
import { InnerWrapper, LockIconContainer, ReduxSwitchWrapper } from './views'
// types
import { Validators } from 'utils/validators'
import { WrappedFieldProps } from 'redux-form/lib/Field'
// utils
import { isBoolean } from 'lodash'

interface Props extends SwitchProps {
  label?: string | React.ReactElement
  reverse?: boolean
  isLocked?: boolean
  validate?: Validators
  alignItems?: string
  justifyContent?: string
  listenOnChange?: (event: React.ChangeEvent | undefined, checked: boolean, name?: string) => void
  preventInitialChange?: boolean
}

const Component: React.FC<Props & WrappedFieldProps> = ({
  label,
  input,
  meta: { touched, error },
  reverse,
  isLocked,
  required,
  alignItems = 'center',
  justifyContent = 'flex-start',
  listenOnChange,
  preventInitialChange,
  ...rest
}) => {
  const onChange = (event: React.ChangeEvent, checked: boolean) => {
    input.onChange(checked)

    if (listenOnChange) {
      listenOnChange(event, checked, input.name)
    }
  }

  React.useEffect(() => {
    if (!preventInitialChange && !isBoolean(input.value)) {
      onChange(undefined, false)
    }
  }, [input.value])

  return (
    <ReduxSwitchWrapper fullWidth>
      <InnerWrapper alignItems={alignItems} justifyContent={justifyContent} reverse={reverse}>
        {label && (
          <InputLabel shrink required={required}>
            {label}
          </InputLabel>
        )}
        <LockIconContainer>
          {isLocked && <LockIconOrigin />}
          <Switch color='primary' checked={!!input.value} {...input} onChange={onChange} {...rest} />
        </LockIconContainer>
      </InnerWrapper>

      {touched && error && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxSwitchWrapper>
  )
}

// @ts-ignore
const ReduxSwitch: React.FC<Props> = (props) => <Field {...props} component={Component} />

export default ReduxSwitch
